import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";

export default function ReshipDialog({ shipment, onClose, onDone }) {
  const [order, setOrder] = useState("");
  const [tracking, setTracking] = useState("");
  const [courier, setCourier] = useState("");
  const [couriers, setCouriers] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (shipment) { setOrder(""); setTracking(""); setCourier(shipment.courier_partner || ""); }
  }, [shipment]);
  useEffect(() => { api.get("/couriers").then((r) => setCouriers(r.data)).catch(() => {}); }, []);

  const submit = async () => {
    if (!order || !tracking || !courier) { toast.error("All fields required"); return; }
    setSaving(true);
    try {
      await api.post(`/shipments/${shipment.id}/reship`, {
        order_id: order, tracking_number: tracking, courier_partner: courier,
      });
      toast.success("New shipment details saved");
      onClose();
      onDone();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Failed to create reshipment");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!shipment} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="reship-dialog">
        <DialogHeader><DialogTitle className="font-heading">New shipment details</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">
          A new shipment was requested for order{shipment ? ` ${shipment.order_id}` : ""}. Enter the new dispatch details,
          or <span className="font-medium">Skip for now</span> — it&apos;ll stay in the pending list until you add them.
        </p>
        <div className="space-y-3 py-2">
          <div><Label>New Order ID</Label><Input data-testid="reship-order" value={order} onChange={(e) => setOrder(e.target.value)} className="mt-1.5" /></div>
          <div><Label>New Tracking Number</Label><Input data-testid="reship-tracking" value={tracking} onChange={(e) => setTracking(e.target.value)} className="mt-1.5" /></div>
          <div>
            <Label>Courier Partner</Label>
            <Select value={courier} onValueChange={setCourier}>
              <SelectTrigger className="mt-1.5" data-testid="reship-courier"><SelectValue placeholder="Select courier" /></SelectTrigger>
              <SelectContent>{couriers.map((c) => <SelectItem key={c.id} value={c.name}>{c.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => { onClose(); onDone(); }} data-testid="reship-skip">Skip for now</Button>
          <Button onClick={submit} disabled={saving} data-testid="reship-save" className="bg-[#0B3D3D] hover:bg-[#0A2E2E] text-white">Save new shipment</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
